import { render, staticRenderFns } from "./TgSearchBtn.vue?vue&type=template&id=bf2beec8"
import script from "./TgSearchBtn.vue?vue&type=script&lang=js"
export * from "./TgSearchBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports